
export const getQueryStringPair = (queryString) => {
    const splittedQuery = queryString.substr(1).split('&')

    let params = {};

    for (let i = 0; i < splittedQuery.length; ++i)
    {
        let param = splittedQuery[i]
            .split('=', 2);
        
        if (param.length !== 2)
            continue;
        
        params[param[0]] = decodeURIComponent(param[1].replace(/\+/g, " "));
    }
        
    return params;
}

export const queryToString = (params) => {
    const paramKeys = Object.keys(params);

    return paramKeys.reduce(function(accu, curr, index) {
        let prepend = '';
        if ( index < paramKeys.lenght -1 ) {
            prepend = "&"
        }

        return accu + curr + "=" + params[curr] + prepend;
    }, '')
}